import { render, staticRenderFns } from "./IconAndTextItem.vue?vue&type=template&id=27d79251&"
import script from "./IconAndTextItem.vue?vue&type=script&lang=ts&"
export * from "./IconAndTextItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports